import { Component, OnInit, Input } from '@angular/core';
import { ResourcesCssService } from '../../pages/resources/resources-css.service'
import { PageHeaderCommands } from '../page-header/page-header.commands'
import { Page } from '../../models/page'
import { Router } from '@angular/router';

@Component({
  selector: 'app-pages-navigation',
  templateUrl: './pages-navigation.component.html',
  styleUrls: ['./pages-navigation.component.scss'],
})
export class PagesNavigationComponent implements OnInit {

  @Input() pages: Page[]
  @Input() topLevel: boolean = true
  @Input() showChildren: boolean = true

  isSelected: boolean = false
  url: string = ''

  constructor(public commands: PageHeaderCommands,
              public resourcesCssService: ResourcesCssService,
              private router: Router) { }

  ngOnInit() {
    this.url = this.router.url.slice(7)
  }

  isCurrentPage(url: string): boolean {
    return this.url === url
  }

  isChildPage(page: Page): boolean {
    return page.parentId > 0
  }

  shouldShowResourceLinks(page: Page = null): boolean {
    if (page == null) {
      return false;
    }
    
    let isResources: boolean = false
    if (this.pages) {
      this.pages.forEach(element => {
        isResources = (element.type === 'resource')
      });
    }
    return this.topLevel && isResources
  }

  navigationClass(page: Page = null): string {
    if (page && this.shouldShowResourceLinks(page)) {
      return 'resource-links'
    }
    return ''
  }
}
